import { render, staticRenderFns } from "./FirmenDublettenZusammenfuehrenModal.vue?vue&type=template&id=2bd97055&"
import script from "./FirmenDublettenZusammenfuehrenModal.vue?vue&type=script&lang=js&"
export * from "./FirmenDublettenZusammenfuehrenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports